import { Button } from '@civilgrid/ui/components';
import { useState } from 'react';
import { runAgencyLoader as apiRunAgencyLoader } from '~/api/internal';
import { Notify } from '~/components2/Notify';
import { MajorHeading } from '../common/Heading';

function RunAgencyLoader() {
  const [isLoading, setIsLoading] = useState(false);

  const onSubmit = async () => {
    try {
      setIsLoading(true);

      const res = await apiRunAgencyLoader();

      if (!res.success) {
        throw 'Error';
      }

      Notify.info({
        title: 'Agency Loader',
        message: 'Agency Loader successfully submitted. You will be notified via email when the job is complete.',
      });
    } catch (_e) {
      Notify.error({
        title: 'Agency Loader',
        message: 'An error occurred during Agency Loader operation. Check logs for details',
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div>
      <MajorHeading tooltip="Run this query to sync agencies from ESRI into Postgres">Run Agency Loader</MajorHeading>
      <Button onClick={onSubmit} loading={isLoading} disabled={isLoading}>
        Run Query
      </Button>
    </div>
  );
}

export default RunAgencyLoader;
